import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import {
  ActivityRoutes,
  AnalyticsRoute,
  CustomerRoutes,
  DocumentRoute,
  InvoicingRoutes,
  PayrollRoutes,
  ProjectRegisterRoutes,
  ProjectRoutes,
  ReportRoutes,
  TaskAndCLaimRoutes,
  TimeTrackingRoutes,
  ToolsRoutes,
  WareHousingRoutes,
  WasteRoutes,
} from "./BusinessRoutesList";
import { WorkspaceRoutes } from "./CommonRoutesList";

import LoadingScreen from "@/components/state-pages/LoadingScreen";
import { ROUTES } from "@/constants/routes_sidebar/routes-constant";
import ProtectedRoute from "@/routers/ProtectedRoutes";

const Login = React.lazy(() => import("@/pages/auth/login/index"));
const Page404 = React.lazy(() => import("@/pages/Page404"));
const Dashboard = React.lazy(() => import("@/pages/dashboard/index"));
const DocketSignature = React.lazy(
  () => import("@/pages/docket-signature/page"),
);
const Estimates = React.lazy(() => import("@/pages/estimates/index"));
const Items = React.lazy(() => import("@/pages/items/index"));
const Roster = React.lazy(() => import("@/pages/roster/index"));
const Template = React.lazy(() => import("@/pages/template/index"));
const CalenderPage = React.lazy(() => import("@/pages/calendar"));
const Fleet = React.lazy(() => import("@/pages/fleet"));
const SettingPage = React.lazy(() => import("@/pages/settings"));
const SupportPage = React.lazy(() => import("@/pages/support"));
const MessagesPage = React.lazy(() => import("@/pages/messages/page"));

const UnderConstructing = React.lazy(
  () => import("@/components/state-pages/UnderConstructing"),
);

const BusinessRoutes = (): React.JSX.Element => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route path='/login/:token?' element={<Login />} />
        <Route path='*' element={<Page404 />} />
        <Route element={<ProtectedRoute />}>
          <Route path={`${ROUTES.WORKFORCE}/*`} element={<WorkspaceRoutes />} />
          <Route path={`${ROUTES.CUSTOMERS}/*`} element={<CustomerRoutes />} />
          <Route path={`${ROUTES.INVOICING}/*`} element={<InvoicingRoutes />} />
          <Route path={`${ROUTES.ROOT}`} element={<Roster />} />
          <Route
            path={`${ROUTES.PROJECT_REGISTER}/*`}
            element={<ProjectRegisterRoutes />}
          />
          <Route path={`${ROUTES.ACTIVITY}/*`} element={<ActivityRoutes />} />
          <Route path={`${ROUTES.ESTIMATES}`} element={<Estimates />} />
          <Route path={`${ROUTES.PROJECTS}/*`} element={<ProjectRoutes />} />
          <Route
            path={`${ROUTES.TASK_CLAIMS}/*`}
            element={<TaskAndCLaimRoutes />}
          />
          <Route path={`${ROUTES.WASTE}/*`} element={<WasteRoutes />} />
          <Route path={`${ROUTES.REPORTS}/*`} element={<ReportRoutes />} />
          <Route
            path={`${ROUTES.TIME_TRACKING}/*`}
            element={<TimeTrackingRoutes />}
          />
          <Route path={`${ROUTES.TOOLS}/*`} element={<ToolsRoutes />} />
          <Route path={`${ROUTES.PAYROLL}/*`} element={<PayrollRoutes />} />
          <Route
            path={`${ROUTES.WARE_HOUSING}/*`}
            element={<WareHousingRoutes />}
          />
          <Route path={`${ROUTES.CALENDAR}/*`} element={<CalenderPage />} />
          <Route path={`${ROUTES.SUPPORT}`} element={<SupportPage />} />
          <Route path={`${ROUTES.ITEMS}`} element={<Items />} />
          <Route path={`${ROUTES.TEMPLATE}`} element={<Template />} />
          <Route path={`${ROUTES.FLEET}`} element={<Fleet />} />
          <Route path={`${ROUTES.MESSAGES}`} element={<MessagesPage />} />
          <Route
            path={`${ROUTES.TASKS}`}
            element={<UnderConstructing title='Task' />}
          />
          <Route
            path={`${ROUTES.OHS}`}
            element={<UnderConstructing title='Ohs' />}
          />
          <Route
            path={`${ROUTES.DOCKET_SIGNATURE}`}
            element={<DocketSignature />}
          />

          <Route
            path={`${ROUTES.ANNOUNCEMENT}`}
            element={<UnderConstructing title='Announcement' />}
          />
          <Route path={`${ROUTES.SETTINGS}`} element={<SettingPage />} />
          {/**
      Analytics route
            */}
          <Route path={`${ROUTES.ANALYTICS}/*`} element={<AnalyticsRoute />} />
          {/**
      document parser
            */}
          <Route
            path={`${ROUTES.DOCUMENT_PARSER}/*`}
            element={<DocumentRoute />}
          />
          {/* OTHER ROUTES */}
          <Route path={`${ROUTES.DASHBOARD}`} element={<Dashboard />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default BusinessRoutes;
